module.exports = __webpack_public_path__ + "img/welcome-design.bb69d319.svg";